import React from "react";
import { MessageEventData, MessageEventDataType } from "@types";
import { env } from "@config";
import { useAppDispatch } from "@store";
import { getCustomToken } from "@store/auth";
import { BrandIcon } from "@taskpane/icons";
import { Button, ButtonSize, ButtonVariant, Header } from "@taskpane/components";
import { withTransition } from "@taskpane/hoc";
import { MicrosoftIcon } from "./icons";
import css from "./SignInScreen.module.scss";

const SignInScreen: React.FC = () => {
  const dispatch = useAppDispatch();

  const attrs = {
    container: {
      className: css.container,
    },
    contentWrapper: {
      className: css.contentWrapper,
    },
    icon: {
      className: css.icon,
    },
    content: {
      className: css.content,
    },
    text: {
      className: css.text,
    },
    title: {
      className: css.title,
    },
    subtitle: {
      className: css.subtitle,
    },
    signInButton: {
      className: css.signInButton,
      variant: ButtonVariant.Secondary,
      size: ButtonSize.S,
      onClick: () => {
        Office.context.ui.displayDialogAsync(
          `${env.signupOrigin}?flow=addin-sign-in`,
          { height: 75, width: 75 },
          (result) => {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
              const dialog = result.value;

              dialog.addEventHandler(Office.EventType.DialogMessageReceived, (event) => {
                if ("message" in event) {
                  const message: MessageEventData<MessageEventDataType> = JSON.parse(event.message);

                  switch (message?.type) {
                    case MessageEventDataType.LOGIN: {
                      const { authCode = "" } = message?.payload || {};

                      if (authCode) {
                        dispatch(getCustomToken(authCode));
                      }

                      break;
                    }
                    default:
                      break;
                  }

                  dialog.close();
                } else {
                  dialog.close();
                }
              });
            }
          }
        );
      },
    },
  };

  return (
    <div {...attrs.container}>
      <Header />
      <div {...attrs.contentWrapper}>
        <BrandIcon {...attrs.icon} />
        <div {...attrs.content}>
          <div {...attrs.text}>
            <h1 {...attrs.title}>Welcome to Substrata</h1>
          </div>
          <Button {...attrs.signInButton}>
            <MicrosoftIcon />
            <span>Continue with Microsoft</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withTransition(SignInScreen);
